<template>
  <div class="product">
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20">
        <div class="titleC">关于广源</div>
        <div class="titleE">ABOUT US</div>
        <div class="titleLine"></div>
        <div class="clear"></div>
        <abouts></abouts>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row>
  </div>
</template>

<script>
import abouts from "../components/about/about.vue";
import request from "../assets/js/request.js";
import qs from "qs";
export default {
  components: {
    abouts,
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  created() {
    request
      .post(
        this.settings.apiBaseUrl + "/api/index/youhuaseo",
        qs.stringify({}),
        {
          headers: {},
        }
      )
      .then((res) => {
        if (res.code == 1) {
        } else {
          this.$message.error(res.msg);
        }
      });
  },
  methods: {
    getStyle(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style scoped="scoped">
.product {
  clear: both;
  width: 100%;
  height: auto;
}

.typeChild {
  display: none;
  position: absolute;
  left: -10%;
  width: 150px;
  height: auto;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  z-index: 99;
}

.typeChild li {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

.typeChild li:hover {
  background-color: #216bd1;
  color: #ffffff;
}

.allType ul li:hover .typeChild {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/about.vue